var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGear({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5144 1.12584C11.8164 0.958052 12.1836 0.958052 12.4856 1.12584L21.4856 6.12584C21.8031 6.30221 22 6.63683 22 7V17C22 17.3632 21.8031 17.6978 21.4856 17.8742L12.4856 22.8742C12.1836 23.0419 11.8164 23.0419 11.5144 22.8742L2.51436 17.8742C2.19689 17.6978 2 17.3632 2 17V7C2 6.63683 2.19689 6.30221 2.51436 6.12584L11.5144 1.12584ZM4 7.5884V16.4116L12 20.856L20 16.4116V7.5884L12 3.14396L4 7.5884ZM12 9.66667C10.6025 9.66667 9.5359 10.7473 9.5359 12C9.5359 13.2527 10.6025 14.3333 12 14.3333C13.3975 14.3333 14.4641 13.2527 14.4641 12C14.4641 10.7473 13.3975 9.66667 12 9.66667ZM7.5359 12C7.5359 9.57085 9.57116 7.66667 12 7.66667C14.4288 7.66667 16.4641 9.57085 16.4641 12C16.4641 14.4292 14.4288 16.3333 12 16.3333C9.57116 16.3333 7.5359 14.4292 7.5359 12Z",
    fill: "#4A5467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGear);
export default __webpack_public_path__ + "static/media/ic-gear.3e5a08065b75bd501f2324ea7578f3fc.svg";
export { ForwardRef as ReactComponent };